import React, { useState } from 'react';
import { getReferralSource, clearReferralSource } from 'viral/viralShare';

export default function ReferralWelcome() {
  const [visible, setVisible] = useState(() => !!getReferralSource());

  if (!visible) return null;

  const dismiss = () => {
    clearReferralSource();
    setVisible(false);
  };

  return (
    <div className="referral-welcome" role="status">
      <p className="referral-welcome__text">
        👋 เพื่อนชวนคุณมาเช็คเลขเด็ด! ลองค้นหาความฝันของคุณเลย
      </p>
      <button type="button" className="referral-welcome__dismiss" onClick={dismiss}>
        เข้าใจแล้ว
      </button>
    </div>
  );
}
